"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _useMetadata = require("./hooks/useMetadata");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MetaActions = function MetaActions(_ref) {
  var _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact;
  var isConnected = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  var _useMyMetadata = (0, _useMetadata.useMyMetadata)(),
    isHandRaised = _useMyMetadata.isHandRaised,
    isBRBOn = _useMyMetadata.isBRBOn,
    toggleHandRaise = _useMyMetadata.toggleHandRaise,
    toggleBRB = _useMyMetadata.toggleBRB;
  if (!isConnected) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    css: {
      gap: compact ? "$4" : "$8"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
      title: "".concat(!isHandRaised ? "Raise" : "Unraise", " hand"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        onClick: toggleHandRaise,
        active: !isHandRaised,
        "data-testid": "".concat(isMobile ? "raise_hand_btn_mobile" : "raise_hand_btn"),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HandIcon, {})
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
      title: "".concat(isBRBOn ? "I'm back" : "I'll be right back"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        onClick: toggleBRB,
        active: !isBRBOn,
        "data-testid": "brb_btn",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.BrbIcon, {})
      })
    })]
  });
};
var _default = MetaActions;
exports["default"] = _default;